import React from 'react';
import { useDashboardContext } from '../../context';
import Modal from '../../../../components/Modal';

const CreateDistributionList = () => {
  const [craeteGroupName, setCraeteGroupName] = React.useState('');
  const { createDist, setCreateDist, setSlectedStudents, slectedStudents, createMessageGroup } =
    useDashboardContext();
  const [validationMsg, setValidationMsg] = React.useState('');

  const createGroupHandler = () => {
    if (craeteGroupName !== '') {
      if (slectedStudents) {
        const loginArray = slectedStudents.map((obj) => obj.login);
        createMessageGroup(craeteGroupName, loginArray);
        setCreateDist(!createDist);
      } else {
        createMessageGroup(craeteGroupName, []);
        setCreateDist(!createDist);
      }
      setCraeteGroupName('');
      setValidationMsg('');
    } else {
      setValidationMsg('Please enter a name for the distribution list.');
    }
  };
  return (
    <Modal
      isOpen={createDist}
      titleName={'Create Distribution List'}
      onClose={() => setCreateDist(!createDist)}
      contentWidth="650px">
      <div className="row">
        <div className="col-12 mb-3">
          <label className="form-label">Enter the name for the distribution list</label>
          <input
            onChange={(event) => setCraeteGroupName(event.target.value)}
            className="form-control"
          />
          {craeteGroupName === '' && validationMsg !== '' && (
            <div className="text-danger">{validationMsg}</div>
          )}
        </div>
        <div className="col-12 d-flex justify-content-end">
          <button onClick={() => setCreateDist(!createDist)} className="btn btn-castleGray me-2">
            Cancel
          </button>
          <button style={{width:'103px !important'}} onClick={createGroupHandler} className="btn btn-castleRed">
            Create List
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateDistributionList;
